var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon || _vm.title)?_c('div',{class:`alert-amo ${_vm.type}`},[(_vm.icon)?_c('i',{class:`icon mdi mdi-${_vm.icon}`}):_vm._e(),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }